import React from 'react';

import InputField from '../../../components/inputs/inputField';
import FieldModal from '../../../components/modals/fieldModal';
import SelectField from '../../../components/inputs/selectField';
import cityTimezones from 'city-timezones';

const durationUnits = [{ value: 'minutes', label: 'Minutes' }, { value: 'hours', label: 'Hours' }];
const dateRangeTypes = [
	{ value: 'fixed', label: 'Days into the future' },
	{ value: 'dateRange', label: 'Within Date Range' },
	{ value: 'indefinite', label: 'Indefinitely into the future' }
];

class NewCalendarModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			calendarName: '',
			submitting: false,
			invalid: false,
			requiredFields: {
				name: false,
				duration: false,
				durationUnit: false,
				timezone: false,
				leadTime: false,
				dateRangeType: false,
			},
			duration: 0,
			durationUnit: '',
			timezone: '',
			leadTime: 0,
			dateRangeType: '',
			futureDays: 0,
			startDate: '',
			endDate: '',
		};
	}

	handleCalendarNameChange = (val) => {
		this.setState({
			calendarName: val.target.value
		});
	};
	handleDurationAmount = (val) => {
		const value = val.target.value;
		if (!isNaN(value) && value >= 0) {
			this.setState({
				duration: value
			});
		} else if (value === 0) {
			this.setState({
				duration: ''
			});
		}
	};

	handleUnit = (val) => {
		this.setState({
			durationUnit: val.value,
		});
	};
	handleTimezone = (val) => {
		this.setState({
			timezone: val.value,
		});
	}
	handleLeadTime = (val) => {

		const value = val.target.value;
		if (!isNaN(value) && value >= 0) {
			this.setState({
				leadTime: value
			});
		} else if (value === 0) {
			this.setState({
				leadTime: ''
			});
		}
	}

	addCalendar = async () => {
		const calendar = {
			name: this.state.calendarName,
			duration: this.state.duration,
			durationUnit: this.state.durationUnit,
			timezone: this.state.timezone,
			leadTime: this.state.leadTime,
			dateRangeType: this.state.dateRangeType,
			futureDays: this.state.futureDays,
			startDate: this.state.startDate,
			endDate: this.state.endDate
		};
		const requiredFields = this.state.requiredFields;
		let valid = true;
		Object.keys(requiredFields).forEach((key) => {
			if (!calendar[key] || calendar[key] === '') {
				requiredFields[key] = true;
				valid = false;
			} else {
				requiredFields[key] = false;
			}
		});
		if (valid) {
			this.setState({ invalid: false, submitting: true });
			await this.props.addCalendar(calendar, this.props.toggle);
		} else {
			this.setState({ invalid: true, requiredFields: requiredFields });
		}
	};

	render() {
		const { isOpen, toggle } = this.props;
		const { calendarName, duration, durationUnit, leadTime, timezone, invalid, requiredFields, submitting, editedCalendar, cityLookup, dateRangeType, futureDays, startDate, endDate } = this.state;
		const cityTimezoneOptions =
			cityLookup != ''
				? cityTimezones.findFromCityStateProvince(cityLookup).map((tz) => {
					return { label: `${tz.city}, ${tz.province}`, value: tz.timezone };
				})
				: [];
			console.log("requiredFields", requiredFields)
		return (

			<FieldModal
				size="medium"
				isOpen={isOpen}
				modalTitle={"Add New Calendar"}
				bodyHeaderText={''}
				bodyDescription={''}
				bodyContent={() => {
					return (
						<div className='sectionContainer'>
							<div className='sectionBody'>
								<InputField
									label="Calendar Name"
									value={calendarName}
									onChange={this.handleCalendarNameChange}
									required={true}
									errorTrigger={requiredFields.name}
									invalid={invalid}
								/>
								<h2 className="blockHeader">Date Range</h2>
								<SelectField
									label="Invitees can schedule..."
									value={dateRangeTypes.find((drt) => drt.value == dateRangeType)}
									options={dateRangeTypes}
									errorTrigger={requiredFields.dateRangeType}
									onChange={(e) => {
										this.setState({
											futureDays: 0,
											startDate: '',
											endDate: '',
											dateRangeType: e.value
										});
									}}
								/>
								{dateRangeType === 'fixed' && (
									<InputField
										label="Days into the future"
										value={futureDays}
										onChange={(e) => {
											this.setState({
												futureDays: e.target.value
											});
										}}
									/>
								)}
								{dateRangeType === 'dateRange' && (
									<div className="flex-ac flex-sb">
										<InputField
											label="Start Date"
											value={startDate}
											type="date"
											classes="mr-10"
											inputIcon={<i className="lar la-calendar" />}
											onChange={(e) => {
												this.setState({
													startDate: e.target.value

												});
											}}
										/>
										<InputField
											label="End Date"
											value={endDate}
											type="date"
											classes="ml-10"
											inputIcon={<i className="lar la-calendar" />}
											onChange={(e) => {
												this.setState({
													endDate: e.target.value
												});
											}}
										/>
									</div>
								)}
								<div className="flex-ac flex-sb">
									<InputField
										label="Duration Amount"
										classes="mr-10"
										type="number"
										min="0"
										value={duration === 0 ? '' : duration}
										onChange={this.handleDurationAmount}
										errorTrigger={requiredFields.duration}


									/>
									<SelectField
										label="Unit"
										style={{ marginLeft: 10 }}
										value={durationUnits.find((dt) => dt.value == durationUnit)}
										options={durationUnits}
										required={true}
										onChange={this.handleUnit}
										errorTrigger={requiredFields.durationUnit}

									/>
								</div>
								<h2 className="blockHeader">Availability</h2>
								<div className="flex-ac flex-sb">
									<SelectField
										label={'Timezone'}
										value={{
											value: timezone,
											label: timezone
										}}
										name="timezones"
										options={cityTimezoneOptions}
										required={true}
										errorTrigger={requiredFields.timezone}
										onInputChange={(text) => {
											this.setState({ editing: true, cityLookup: text });
										}}
										noOptionsMessage={({ inputValue }) =>
											!inputValue ? 'Type city name to get options' : 'No cities match your search'}
										onChange={this.handleTimezone}
										invalid={invalid}
									/>
									<InputField
										label="Lead Time Needed (days)"
										classes="ml-10 mt-10"
										type="number"
										value={leadTime == 0 ? '' : leadTime}
										onChange={this.handleLeadTime}
										required={true}
										errorTrigger={requiredFields.leadTime}
										invalid={invalid}
									/>
								</div>
							</div>
						</div>)
				}}
				toggle={toggle}
				actionButtonLabel={!submitting ? 'Add' : 'Adding...'}
				actionButton={() => this.addCalendar()}
				actionButtonDisabled={submitting}
			></FieldModal>

		);
	}
}

export default NewCalendarModal;
